function directive() {
    return {
        link: function ($scope, element, attrs) {
            var app = require('../../../system/assets/scripts/app.js');

            var sidebar, body;
            var floating_logo = function () {
                var viewPort = $(window).height();
                var sidebarHeight = $('.page-sidebar').height() + 180;
                if (viewPort < sidebarHeight) {
                    $('#footimg').css({ display: 'none' });
                }
                else {
                    $('#footimg').css({ position: 'fixed', bottom: 30, display: '' });
                }
            };
            floating_logo();
            $('.page-sidebar-menu').css({ "max-height": "100%" });
            // $(window).scroll(function () {
            //     $('.page-sidebar').css({ position: 'fixed' });
            // });
            // BOTTOM LEFT LOGO VISIBILITY
            $('.page-sidebar li a').click(function () {
                setTimeout(function () {
                    floating_logo();
                }, 150);
            });

            $scope.$on('window-resize', function () {
                floating_logo();
            });
            // sidebar memory
            if (!localStorage.getItem('sidebar')) {
                localStorage.setItem('sidebar', 1);
            }
            if (localStorage.getItem('sidebar') == 0) { // keep sidebar consistent between pages
                body = $('body');
                sidebar = $('.page-sidebar');
                $('.sidebar-search', sidebar).removeClass('open');
                body.addClass('page-sidebar-closed');
            } else {
                body = $('body');
                sidebar = $('.page-sidebar');
                body.removeClass('page-sidebar-closed');
                sidebar.css('width', '');
            }
            app.init();
        }
    };
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/sidebar/sidebar.js
 **/